export class Controller {

	
	
    /** @ngInject */
    constructor($timeout,$state) {
        this.$timeout = $timeout;
        this.$state=$state;
    }

    $onChanges({options}) {
    	this.timeToClose = 4000;
        if (options!== undefined ) {
        	//console.log('ifst ',this.$state);
        	if(options.currentValue.variables['closeNow']===true){
        		this.visible =false;
        		this.timeToClose = 0;
        		
        	} else {
        		this.visible = !!options.currentValue.key;

        	}
           // this.update(options.currentValue || {});
        }
    }

    update({key, autoDismiss}) {
        this.visible = !!key;

        if (autoDismiss) {
            this.$timeout(this.timeToClose)
                .then(() => this.visible = false);
        }
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-constant-alert/sp-constant-alert.controller.js